/*
    ==== COMMON CONSTANTS ====
*/

import {
    CONSERVATION_TYPES,
    CONSTRUCTION_TYPES,
    CORE_TYPES,
    DRILLING_HISTORY_TYPES,
    DRILLING_TYPES,
    GIS_CONTROL_CONCLUSION_TYPES,
    GIS_DRILLING_CONCLUSION_TYPES,
    INCLINOMETRY_TYPES,
    ISOLATION_TYPES,
    PERFORATION_TYPES,
    TEXHNICAL_INFORMATION_ON_WELLS,
    COORDINATES_TYPES,
    GTM_TYPES,
    LIQUIDATION_TYPES,
    GIS_DRILLING_CURVES_TYPES,
    GIS_CONTROL_CURVES_TYPES,
    GRP_TYPES,
    RESERVOIR_PRESSURES_TYPES,
    MEASUREMENTS_TYPES,
    FLUID_TYPES,
    MODELING_TYPES,
    TESTING_TYPES,
    REPORTS_NIPI_TYPES,
    UNDERGROUND_EQUIPMENT_TYPES,
    POTENTIALS_TYPES,
    WELL_BREAKDOWN_TYPES,
    REGISTRY_TYPES,
    GDIS_RESULTS_TYPES,
    REPAIRS_TYPES,
    REFERENCE_TYPES,
    STRATIGRAPHIC_BREAKDOWN_TYPES,
} from '@/components/Reports/Sidebar/Filter/RequestsBlock/types';
import { MODAL_TYPES } from '@/components/Reports/Sidebar/Form/forms/RequestsBlock/types';

/*
    Фильтр для отчетов может сильно перестраиваться, в зависимости от выбора типа отчета.

    * BASE - базовый вид фильтра, поддерживает все виды отчетов, описанных в документации.
    * GDI - нестандартный вид фильтр (только для отчета типа - ГДИ)
    * GOSPLAN - нестандартный вид фильтр (только для отчета типа - Гос. План)
    * MER - нестандартный вид фильтр (только для отчета типа - МЭР)

    Именно этот список будет отвечать за добавление нестандартных фильтров для отчетов
*/
export const reportFilters = {
    BASE: 'base',
    GDI: 'gdi',
    GOSPLAN: 'gosplan',
    MER: 'mer',
    TECH_INFO: 'TechInfo',
    WELL_RESEARCH: 'WellResearch',
    GDS: 'GDS',
    ESRI: 'ESRI',
    REQUESTS_BLOCK: 'requestsBlock',
    PLAN_ORDER: 'PlanOrder',
    EQUIPMENT_SELECTION: 'EquipmentSelection',
    KRS_AND_GTM: 'KRS',
};

export const periods = {
    MONTH: 'month',
    YEAR: 'year',
    PERIOD: 'period',
    ALL: 'all',
};

/*
    Справочник способов получения отчетов.

    * create - создание отчета и загрузка его в iFrame
    * download - выгрузка отчета в xlsx
*/
export const submitType = {
    CREATE: 'create',
    DOWNLOAD: 'download',
};

/*
    ==== BASE FILTER CONSTANTS ====
*/

/*
    Справочник типов форм.
    За тем или иным отчетом может быть закреплена своя форма. (см ТЗ)

    * BASE_GROUPING - базовая форма (с группировкой): период, дата + группировка по элементам
    * BASE - базовая форма: период, дата (число)
    * BASE_ONLY_PERIOD - базовая форма без группировки, где нужно проставить ТОЛЬКО период
    * SHORT_BASE_GROUPING - упрощенная форма (с группировкой): месяц, год + группировка по элементам
    * SHORT_BASE - упрощенная форма: месяц, год
    * SAMPLING_GKZ - форма для отчета "Опробование ГКЗ"
    * EMPTY - отсутствие формы: необходим, чтобы пропускать шаги при заполнении полей для отчета (например, фильтр)
*/
export const reportForms = {
    COMPLETENESS: 'completeness',
    BASE_GROUPING: 'baseGrouping',
    MER: 'mer',
    BASE: 'base',
    BASE_ONLY_PERIOD: 'baseOnlyPeriod',
    SHORT_BASE_GROUPING: 'shortBaseGrouping',
    SHORT_BASE: 'shortBase',
    SAMPLING_GKZ: 'samplingGKZ',
    KRS_AND_GTM: 'KRS',
    EMPTY: 'withoutForm',
    GDS: 'GDS',
    ESRI: 'ESRI',
    REQUESTS_BLOCK: 'requestsBlock',
};


export const NON_MODAL_TYPES = [
    ...DRILLING_TYPES,
    ...ISOLATION_TYPES,
    ...DRILLING_HISTORY_TYPES,
    ...CORE_TYPES,
    ...CONSERVATION_TYPES,
    ...CONSTRUCTION_TYPES,
    ...PERFORATION_TYPES,
    ...TEXHNICAL_INFORMATION_ON_WELLS,
    ...INCLINOMETRY_TYPES,
    ...GIS_CONTROL_CONCLUSION_TYPES,
    ...GIS_DRILLING_CONCLUSION_TYPES,
    ...GIS_DRILLING_CURVES_TYPES,
    ...GIS_CONTROL_CURVES_TYPES,
    ...GRP_TYPES,
    ...GTM_TYPES,
    ...RESERVOIR_PRESSURES_TYPES,
    ...MEASUREMENTS_TYPES,
    ...FLUID_TYPES,
    ...COORDINATES_TYPES,
    ...MODELING_TYPES,
    ...TESTING_TYPES,
    ...REPORTS_NIPI_TYPES,
    ...UNDERGROUND_EQUIPMENT_TYPES,
    ...POTENTIALS_TYPES,
    ...WELL_BREAKDOWN_TYPES,
    ...REGISTRY_TYPES,
    ...GDIS_RESULTS_TYPES,
    ...REPAIRS_TYPES,
    ...REFERENCE_TYPES,
    ...STRATIGRAPHIC_BREAKDOWN_TYPES,
    ...LIQUIDATION_TYPES,
].filter(type => !MODAL_TYPES.includes(type));

/*
    * Список отчетов, не имеющих форму.

    Этот список нужен, когда при нажатии на кнопку "Создать отчет" - сразу уходит
    запрос на формирование отчета. Это редкий случай. Обычно при нажатии на кнопку появляется форма, уточняющая
    параметры запроса.
*/
export const reportsWithoutForm = ['GDI'];
export const checkReportsWithoutForm = reportValue => {
    return reportsWithoutForm.includes(reportValue);
};

/*
    * Список отчетов, которые не требуют манипуляции с деревом.

    То есть любое действие с деревом должно быть заблокировано.
    Планируется, что таких отчетов будет несколько.
*/
export const reportsWithoutTree = ['GosPlan'];
export const checkReportsWithoutTree = reportValue => {
    return reportsWithoutTree.includes(reportValue);
};

export const reportFiltersNames = {
    gdi: 'Гидродинамические исследования',
    gosplan: 'Госплан',
    mer: 'МЭР',
    TechInfo: 'Техническая информация',
    WellResearch: 'Исследования скважин',
    GDS: 'Выгрузка данных для ГДС',
    ESRI: 'Выгрузка геоданных в формате ESRI',
    PlanOrder: 'План-заказ на ремонт',
    EquipmentSelection: 'Шаблон подбора оборудования',
    KRS: 'Сводка КРС и ГТМ',
};
